import { useAxios } from '@healthblocks-io/core'
import { useCallback } from 'react'

import { useAxiosAsync } from '@/@bothrs-react/hooks/useAxiosAsync'
import { useIntegrationAxios } from '@/modules/healthblocks/hooks/useIntegrationAxios'

import type { PartiallyRequired } from '@/utils/typescript'
import type { Appointment } from '../types/appointment.types'

function useCancelAppointment() {
  const hbAxios = useAxios()
  const axios = useIntegrationAxios()

  const cancelAppointment = useCallback(
    async (payload: PartiallyRequired<Partial<Appointment>, 'id'>) => {
      const appointmentId = payload.slug?.replace('synops_', '')
      const result = await axios.get('/synops/cancel-appointment', {
        params: {
          appointmentId,
        },
      })

      // Update meta to be cancelled
      await hbAxios.patch(`/appointment/${payload.id}`, {
        status: 'cancelled',
      })

      return result
    },
    [axios, hbAxios],
  )

  return useAxiosAsync(cancelAppointment)
}

export { useCancelAppointment }
